export default __webpack_public_path__ + "static/N0048-ba8b28b79895692a03a9b1a51e1902d2.png";